import { render, staticRenderFns } from "./Navbar1.vue?vue&type=template&id=95f19b60&"
import script from "./Navbar1.vue?vue&type=script&lang=js&"
export * from "./Navbar1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports